export const initBookletRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/booklet-templates",
          name: "booklet",
          component: () => import("@/pages/manage/booklet-templates/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
        {
          path: "/manage/booklet-templates/:id",
          name: "booklet-id",
          component: () => import("@/pages/manage/booklet-templates/id.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
      ];
